import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppFilter } from "app/models/app-filter.model";
import { AbCorrespondencia } from 'app/abstract/full-pages/correspondencia/correspondencia.abstract';


@Injectable({ providedIn: 'root' })
export class CorrespondenciaService extends AbCorrespondencia {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllCorrespondencias(filter: AppFilter): Observable<any> {
    return this.get(`correspondencias/filter/${filter.encode()}`);
  }

  public saveCorrespondencias(correspondencia: any): Observable<any> {
    return this.save("correspondencias/", correspondencia);
  }

  public getCorrespondencia(id: number): Observable<any> {
    return this.get("correspondencias/", id);
  }

  public getCorrespondenciasUnidadePessoa(filter: AppFilter): Observable<any> {
    return this.get(`correspondencias/correspondencias_unidade_pessoa/${filter.encode()}`);
  }

  public getCorrespondenciasUnidadePessoaV2(filter: AppFilter): Observable<any> {
    return this.get(`api/v1/correspondencias/unidade-pessoa/${filter.encode()}`);
  }

  public gerarRelatorio(filter: AppFilter): Observable<any> {
    return this.get(`correspondencias/relatorio/${filter.encode()}`);
  }

  public getComprovanteCorrespondenciaById(dispositivoId: number): Observable<any> {
    return this.get(`correspondencias/comprovante/${dispositivoId}`);
  }
}
